// @flow

import * as atypes from "src/constants/actionTypes";
import type { Action } from "src/types";

type OrgSetupDetails = {
  title: string,
  member1: ?string,
  member2: ?string,
  member3: ?string,
  domain: string,
  autoJoin: boolean
};

const setupOrg = ({
  title,
  member1,
  member2,
  member3,
  domain,
  autoJoin
}: OrgSetupDetails): Action => ({
  type: atypes.SETUP_ORG_REQUEST,
  payload: {
    title,
    member1,
    member2,
    member3,
    domain,
    autoJoin
  }
});

const setupOrgSuccess = (): Action => ({
  type: atypes.SETUP_ORG_SUCCESS,
  payload: {}
});

const setupOrgFailed = (error: Object): Action => ({
  type: atypes.SETUP_ORG_FAILURE,
  payload: error
});

const clearAllErrors = (): Action => ({
  type: atypes.CLEAR_SIGNUP_ERRORS,
  payload: {}
});

const joinExistingOrg = (orgId: number): Action => ({
  type: atypes.JOIN_EXISTING_ORG_REQUEST,
  payload: {
    orgId
  }
});

const join = (payload: {
  email: string,
  displayName: string,
  password: string,
  profilePicture: any,
  orgId: number
}): Action => ({
  type: atypes.JOIN_ORG_REQUEST,
  payload
});

const srwSignUp = (): Action => ({
  type: atypes.SRW_SIGN_UP,
  payload: {}
});

export {
  setupOrg,
  setupOrgFailed,
  setupOrgSuccess,
  clearAllErrors,
  join,
  joinExistingOrg,
  srwSignUp
};
